import { useEffect, useRef } from 'react'

import { HcModal } from '@cosmos-web/hc-modal'

import clsx from 'clsx'
import { useTheme, ThemeMode } from 'src/lib/contexts'

import styles from './modal.module.css'
import { MODAL_LISTENERS, type ModalProps } from './types'

import { ReactPortal } from '../reactPortal'

const Modal = ({ children, className, onOpenModal, onCloseModal }: ModalProps): JSX.Element => {
  const modalRef = useRef<HTMLHcModalElement>(null)
  const { theme } = useTheme()

  useEffect(() => {
    const listener = (): void => {
      modalRef.current?.open()
    }

    window.addEventListener(MODAL_LISTENERS.OPEN, listener)

    return (): void => {
      window.removeEventListener(MODAL_LISTENERS.OPEN, listener)
    }
  }, [])

  useEffect(() => {
    const listener = (): void => {
      modalRef.current?.close()
    }

    window.addEventListener(MODAL_LISTENERS.CLOSE, listener)

    return (): void => {
      window.removeEventListener(MODAL_LISTENERS.CLOSE, listener)
    }
  }, [])

  return (
    <ReactPortal wrapperId='modal'>
      <HcModal
        className={clsx(
          'text-neutral-900',
          styles.modal,
          {
            [styles.modalDark]: theme === ThemeMode.DARK
          },
          className
        )}
        ref={modalRef}
        onOpenModal={onOpenModal}
        onCloseModal={onCloseModal}>
        {children}
      </HcModal>
    </ReactPortal>
  )
}

export default Modal
